<template>
  <div>
    <module-card :title="'活动: ' + info.activityId + '  ' + info.activityName">
      <el-form :model="searchForm" :inline="true" label-width="85px" label-position="left">
        <el-form-item label="录入时间">
          <date-range-picker :value="inputTime" @getChange="value => inputTime = value" :clearable="true"></date-range-picker>
        </el-form-item>
        <el-form-item label="系统绑卡时间" label-width="100px">
          <date-range-picker :value="bindTime" @getChange="value => bindTime = value" :clearable="true"></date-range-picker>
        </el-form-item>
        <el-form-item label="更新时间">
          <date-range-picker :value="updateTime" @getChange="value => updateTime = value" :clearable="true"></date-range-picker>
        </el-form-item>
        <el-form-item label="乐刷商户号">
          <el-input v-model="searchForm.merchantId" placeholder="请输入商户号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model="searchForm.agentId" placeholder="请输入代理商编号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="开户人">
          <el-input v-model="searchForm.settleName" placeholder="请输入开户人" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="商户开卡状态" label-width="100px">
          <el-select v-model="searchForm.status" multiple placeholder="请选择开卡状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="拓展来源">
          <el-select v-model="searchForm.extendedSource" clearable placeholder="请选择拓展来源">
            <el-option
              v-for="item in extendedSourceList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加来源">
          <el-select v-model="searchForm.source" clearable placeholder="请选择添加来源">
            <el-option label="后台录入" :value="10"></el-option>
            <el-option label="小程序添加" :value="0"></el-option>
            <el-option label="商户端h5" :value="20"></el-option>
            <el-option label="联合收单App" :value="70"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开卡服务">
          <el-select v-model="searchForm.optType" clearable placeholder="请选择开卡服务">
            <el-option label="否" :value="10"></el-option>
            <el-option label="是-上门开卡" :value="0"></el-option>
            <el-option label="是-网点开卡" :value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="补贴对象" v-if="info.subType !== 0">
          <el-select v-model="searchForm.settleType" clearable placeholder="请选择补贴对象">
            <el-option
              v-for="item in settleList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动参与状态" label-width="100px">
          <el-select v-model="searchForm.joinState" clearable placeholder="请选择活动参与状态">
            <el-option label="全部"></el-option>
            <el-option label="正常" value="0"></el-option>
            <el-option label="已退出" value="1"></el-option>
          </el-select>
        </el-form-item>
        <div style="margin-bottom: 20px">
          <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
          <auth-button opt="export" label="导出" :loading="exportLoading" @click.native="exportMerchant"></auth-button>
        </div>
        <div>
          <auth-button opt="merchant_info_export" :plain="true" label="导出已绑卡【商户资料】" @click.native="toExportInfo"></auth-button>
          <auth-button opt="merchant_summary_export" :plain="true" label="导出已绑卡商户【交易汇总】" @click.native="toExportSummery"></auth-button>
          <auth-button opt="merchant_details_export" :plain="true" label="导出已绑卡商户【交易明细】" @click.native="toExportDetails"></auth-button>
          <auth-button opt="merchant_summary_export_bank" :plain="true" label="导出交易汇总（银行）" @click.native="toExportBankSummery"></auth-button>
          <auth-button opt="merchant_info_export" :plain="true" label="导出未预约商户" @click.native="toExportWithoutAppointment"></auth-button>
        </div>
      </el-form>
    </module-card>
    <module-card title="商户管理">
      <auth-button opt="add_unbound" v-show="this.info.subType !== 0" label="录入待开卡商户" icon="el-icon-plus" @click.native="toAddUnbound"></auth-button>
      <auth-button opt="add_bound" label="添加已绑卡商户" icon="el-icon-plus" @click.native="toAddBound"></auth-button>
      <!-- <batch-import
        class="batchImport"
        button-text="批量修改商户信息"
        submit-name="batchUpdate"
        :tips-text="importTips"
        templateName="批量修改商户信息模板"
        dialog-title="批量修改"
        @submit="importSubmit"
        failKey="failMerchants"
        opt="batch_update"
        :tableList="[
          { label: '商户编号', prop: 'mcode' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"
        :plain="true"
        :hasIcon="false"
        :otherData="{
          activityId: info.activityId
        }"
        :limitNum="3000"
        result-title="修改"></batch-import> -->
      <batch-import
        class="batchImport"
        button-text="批量修改开卡状态"
        submit-name="batchUpdateCard"
        templateName="批量修改开卡状态模板"
        dialog-title="批量修改开卡状态"
        @submit="importSubmit"
        failKey="failMerchants"
        opt="batch_update_card"
        :tableList="[
          { label: '商户编号', prop: 'merchantId' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"
        :plain="true"
        :hasIcon="false"
        :otherData="{
          activityId: info.activityId
        }"
        result-title="修改"></batch-import>
      <auth-button class="batchImport" :plain="true" opt="batch_openCard" label="批量开卡指派" @click.native="showBatchAssignDialog = true" v-if="info.subType !== 0"></auth-button>
      <batch-import
        class="batchImport"
        button-text="批量退出活动"
        submit-name="batchExitActivity"
        templateName="批量退出活动模板"
        dialog-title="批量退出活动"
        @submit="importSubmit"
        failKey="failMerchants"
        opt="batch_exit_activity"
        :limitNum="1000"
        :otherTips="['商户退出活动后额度包余额清零且补贴状态关闭；']"
        :tableList="[
          { label: '商户编号', prop: 'merchantId' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"
        :plain="true"
        :hasIcon="false"
        :otherData="{
          activityId: info.activityId
        }"
        result-title="修改"></batch-import>
      <el-table class="table" border :data="merchantList" v-loading="searchLoading">
        <el-table-column
          label="录入时间"
          width="160"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="系统绑卡时间"
          width="160"
          prop="accountBindTime">
        </el-table-column>
        <el-table-column
          label="乐刷商户号"
          width="110"
          prop="merchantCode">
        </el-table-column>
        <el-table-column
          label="商户名称"
          min-width="150"
          prop="shopName">
        </el-table-column>
        <el-table-column
          label="商户地址"
          prop="address"
          min-width="180">
        </el-table-column>
        <el-table-column
          label="开卡状态"
          width="80"
          prop="status">
          <template slot-scope="scope">
            <span>{{getListText(scope.row.status, statusList)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="开卡服务"
          width="100"
          prop="optType">
          <template slot-scope="scope">
            <span v-if="scope.row.optType === 10">否</span>
            <span v-else-if="scope.row.optType === 0">是-上门开卡</span>
            <span v-else>是-网点开卡</span>
          </template>
        </el-table-column>
        <el-table-column label="银行网点" prop="bankName"></el-table-column>
        <el-table-column label="网点银行经理" prop="managerName"></el-table-column>
        <!-- <el-table-column
          label="录入人"
          min-width="120"
          prop="keyBoarder"
          v-if="!isBank">
        </el-table-column>
        <el-table-column
          label="录入人名称"
          min-width="120"
          prop="keyBoarderName"
          v-if="!isBank">
        </el-table-column>
        <el-table-column
          label="推广员手机"
          min-width="150"
          prop="marketerMobile"
          v-if="!isBank">
        </el-table-column>
        <el-table-column
          label="添加来源"
          width="120"
          prop="source">
          <template slot-scope="scope">
            <span>{{getListText(scope.row.source, sourceList)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="一代编号"
          min-width="100"
          prop="agentId">
        </el-table-column>
        <el-table-column
          label="一代名称"
          min-width="150"
          prop="agentTitle"
          v-if="!isBank">
        </el-table-column>
        <!-- <el-table-column
          label="拓展来源"
          width="100"
          prop="extendedSource">
          <template slot-scope="scope">
            <span>{{getListText(scope.row.extendedSource, extendedSourceList)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="开卡推广员" prop="marketerName" v-if="!isBank"></el-table-column>
        <el-table-column label="活动参与状态" prop="joinState">
          <template slot-scope="scope">
            <div>
              {{scope.row.joinState === 0?"正常":"已退出"}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="更新时间"
          width="160"
          prop="updateTime">
        </el-table-column>
        <el-table-column
          label="首次绑卡时间"
          width="160"
          prop="firstAccountBindTime">
        </el-table-column>
        <!-- <el-table-column
          label="最后操作人"
          width="100"
          prop="operator">
        </el-table-column> -->
        <el-table-column
          label="操作(超级管理员)"
          fixed="right"
          width="350">
          <template slot-scope="scope">
            <auth-button auth-type="span" opt="detail" label="商户信息" @click.native="checkDetails(scope.row)"></auth-button>
            <!-- <auth-button auth-type="span" opt="edit_info" label="编辑资料" @click.native="editMerchant(scope.row, 'info')"></auth-button>
            <auth-button auth-type="span" opt="edit_status" label="修改状态" @click.native="editMerchant(scope.row, 'state')" v-if="scope.row.optType !== 10"></auth-button>
            <auth-button auth-type="span" opt="download_idcard" label="下载身份证" @click.native="downloadIdCard(scope.row)" v-if="scope.row.optType !== 10 && info.subType === 20"></auth-button> -->
            <auth-button v-if="[0, 1, 2, 6, 9].includes($store.state.userInfo.userType) && info.type === 10" auth-type="span" label="删除" opt="delete" @click.native="deleteActivity(scope.row)"></auth-button>
            <auth-button v-if="$store.state.userInfo.userType === 0 && info.type !== 10" auth-type="span" label="删除" opt="delete" @click.native="deleteActivity(scope.row)"></auth-button>
            <auth-button auth-type="span" opt="bind_record" label="开卡状态" @click.native="checkOpenCard(scope.row)"></auth-button>
            <auth-button v-if="scope.row.optType !== 10" auth-type="span" opt="openCard_assign" label="开卡指派" @click.native="checkOpenCardAssign(scope.row)"></auth-button>
            <auth-button v-if="scope.row.joinState!==1" auth-type="span" opt="exit_activity" label="退出活动" @click.native="doExitActivity(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :count="total"
        :edit-size="true"
        :page-no="searchForm.pageNo"
        :size="searchForm.pageSize"
        @changePage="value => { searchForm.pageNo = value;getMerchantList() }"
        @changeSize="value => { searchForm.pageSize = value;searchForm.pageNo = 1;getMerchantList() }"
      ></pagination>
    </module-card>
    <dialog-info :title="isCheckDetail? '详情' : (merchant.id ? '编辑' : '添加商户')"
    :visible.sync="showDialog"
    :confirmLoading="editLoading"
    :cancel-text="isCheckDetail? '关闭' : '取消'"
    :show-confirm-btn="!isCheckDetail"
    @confirm="submitMerchant"
    size="middle"
    @close="clearMerchant">
      <el-tabs v-model="merchantFlag" v-show="!isCheckDetail && merchant.id === ''">
        <el-tab-pane label="单个录入" name="single"></el-tab-pane>
        <el-tab-pane label="批量录入" name="batch"></el-tab-pane>
      </el-tabs>
      <div v-show="merchantFlag === 'batch'">
        <p class="activityName">{{info.activityName}}</p>
        <p class="activityId">活动编号：{{info.activityId}}</p>
        <div class="import-tip">导入须知：请下载批量录入待开卡商户模板文件，按照模板输入，每次导入不超过3000个</div>
        <el-button  @click="getMultiFiles" size="small" class="import">批量导入</el-button>
        <a href="static/批量录入待开卡商户模板.xlsx" class="downloadLink">下载模板文件</a>
        <input type="file" ref="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
        <p>仅支持.xls、.xlsx格式</p>
        <el-col v-if="multiFileName !== ''" class="hasSelect">
          <span>已选择: {{ multiFileName }}</span>
          <i class="el-icon-remove removeIcon" @click="removeFile"></i>
        </el-col>
      </div>
      <el-form ref="merchant" :model="merchant" :rules="ruleData" label-width="80px" label-position="left" :disabled="isCheckDetail" class="merchantForm" v-loading="checkLoading" v-show="merchantFlag === 'single'">
        <p class="activityName">{{info.activityName}}</p>
        <p class="activityId">活动编号：{{info.activityId}}</p>
        <el-form-item prop="merchantCode" label="乐刷商编">
          <div>
            <el-input v-model.trim="merchant.merchantCode" :disabled="merchant.id !== ''" placeholder="请输入商户乐刷商编" class="merchantIdInput"></el-input>
            <el-button type="primary" v-if="!isCheckDetail && merchant.id === ''" :disabled="!merchant.merchantCode" @click="getMerchantInfo" :loading="checkLoading">自动填入资料</el-button>
          </div>
        </el-form-item>
        <el-form-item prop="settleName" label="结算人" v-if="merchant.optType !== 10">
          <el-input v-model="merchant.settleName" placeholder="请输入结算人/开户人姓名" :disabled="editType === 'state' || [10].includes($store.state.userInfo.userType)"></el-input>
        </el-form-item>
        <el-form-item prop="idCardNo" label="身份证号" v-if="info.subType === 20">
          <el-input v-model="merchant.idCardNo" placeholder="请输入开户人身份证号码" :disabled="editType === 'state'"></el-input>
        </el-form-item>
        <el-form-item label-width="0" v-if="info.subType === 20">
          <el-row type="flex">
            <el-form-item prop="idCardFront">
              <upload-img-ele
                :required="false"
                ref="idCardFront"
                :clearable="true"
                valueName="idCardFront"
                :value="merchant.idCardFront"
                label="身份证头像面"
                :disabled="isCheckDetail || editType === 'state'"
                :example="idcardFront_eg"
                @upload="uploadSuccess"></upload-img-ele>
            </el-form-item>
            <el-form-item prop="idCardBack" class="marginLeft">
              <upload-img-ele
                :required="false"
                ref="idCardBack"
                :clearable="true"
                valueName="idCardBack"
                :value="merchant.idCardBack"
                label="身份证国徽面"
                :disabled="isCheckDetail || editType === 'state'"
                :example="idcardBack_eg"
                @upload="uploadSuccess"></upload-img-ele>
            </el-form-item>
          </el-row>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号" v-if="merchant.optType !== 10">
          <el-radio-group v-model="merchant.mobileType" @change="merchant.mobile = ''" :disabled="editType === 'state'">
            <div class="radioDiv">
              <el-radio :label="0" :disabled="!merchant.baseMobile">
                默认手机：{{merchant.baseMobile}}
              </el-radio>
            </div>
            <div>
              <el-radio :label="1">
                使用新手机号：
                <el-input v-model="merchant.mobile" placeholder="请输入手机号" :disabled="merchant.mobileType === 0 || editType === 'state'" class="displayBlock"></el-input>
              </el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="shopName" label="门店名称">
          <el-input v-model="merchant.shopName" placeholder="请输入店铺名称" :disabled="editType === 'state' || merchant.optType === 10 || [10].includes($store.state.userInfo.userType)"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <address-select class="addressSelect" ref="addressSelectForm" v-model="merchant.address"  :readOnly="isCheckDetail || editType === 'state' || merchant.optType === 10 || [10].includes($store.state.userInfo.userType)" @getValue="getAddress" :required="merchant.optType !== 10"></address-select>
        </el-form-item>
        <el-form-item label="开卡服务" v-if="!merchant.id">
          <el-radio-group v-model="merchant.optType" clearable placeholder="请选择开卡服务" :disabled="editType === 'state'">
            <el-radio :key="0" :label="0" v-if="info.subType !== 30">上门开卡</el-radio>
            <el-radio :key="30" :label="30" v-if="info.subType !== 10">网点开卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="银行网点" v-if="merchant.id === '' || merchant.optType !== 10"> -->
        <!-- <el-form-item label="银行网点">
          <el-select v-model="merchant.cardBankNewId" clearable placeholder="请选择上门开卡的银行网点" @change="handleBankChange" ref="cardBankNewId" :disabled="editType === 'state' || [30, 40, 0].includes(merchant.status)">
            <el-option
              v-for="item in bankList"
              :key="item.bankNewId"
              :label="item.bankName"
              :value="item.bankNewId">
            </el-option>
          </el-select>
          <span class="downloadLink" style="margin-left: 12px;" @click="queryAutoBank" v-loading="queryLoading" v-show="editType !== 'state'">系统自动匹配</span>
        </el-form-item>
        <el-form-item label="银行网点客户经理" v-if="merchant.id === '' || merchant.optType !== 10" label-width="130px">
          <el-select v-model="merchant.managerId" clearable placeholder="请选择银行网点客户经理" :disabled="editType === 'state' || [30, 40, 0].includes(merchant.status)">
            <el-option
              v-for="item in managerList"
              :key="item.managerId"
              :label="item.name"
              :value="item.managerId">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="开卡要求" v-if="info.openCardDemand !== 0">
          <el-checkbox-group v-model="openCardDemandList" style="display: inline-block;" :disabled="editType === 'state'">
            <el-checkbox :label="1" v-if="info.openCardDemand !== 10">社保</el-checkbox>
            <el-checkbox :label="10" v-if="info.openCardDemand !== 1">居住证</el-checkbox>
          </el-checkbox-group>
          <span class="downloadLink" style="margin-left: 24px;">(具有请勾选)</span>
        </el-form-item>
        <el-form-item label="开卡推广员备注" label-width="120px">
          <el-input type="textarea" maxlength="200" v-model="merchant.remark" placeholder="请输入备注信息" :disabled="editType === 'state'"></el-input>
        </el-form-item>
        <el-form-item prop="extendedSource" label="拓展来源">
          <el-radio-group v-model="merchant.extendedSource" :disabled="editType === 'state' || [10].includes($store.state.userInfo.userType)">
            <el-radio
              v-for="item in extendedSourceList"
              :key="item.value"
              :label="item.value">
              {{item.text}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="补贴对象" prop="settleType">
          <el-radio-group v-model="merchant.settleType" :disabled="editType === 'state'">
            <el-radio :key="0" :label="0" v-show="settleType !== 10">补贴给商户</el-radio>
            <el-radio :key="10" :label="10" v-show="settleType !== 0 && info.type === 10">补贴给代理商</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="银行网点" prop="actualManagerId" label-width="100px">
          <el-select v-model="merchant.actualManagerId" placeholder="请选择银行网点" style="width: 350px">
            <el-option
              v-for="item in actualManagerList"
              :key="item.managerId"
              :label="item.label"
              :value="item.managerId">
            </el-option>
          </el-select>
        </el-form-item> -->

<!--        <el-form-item label="客户经理工号" label-width="100px">-->
<!--          <el-input v-model="merchant.accountManagerNo" placeholder="请输入商户推荐的银行客户经理工号" :disabled="editType === 'state'"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="客户经理姓名" label-width="100px">-->
<!--          <el-input v-model="merchant.accountManagerName" placeholder="请输入商户推荐的银行客户经理姓名" :disabled="editType === 'state'"></el-input>-->
<!--        </el-form-item>-->
        <!-- <el-form-item label="开卡客户经理" prop="actualManagerId" label-width="100px">
          <el-select v-model="merchant.actualManagerId" placeholder="请选择实际开卡的客户经理" style="width: 350px" :disabled="[30, 40, 0].includes(merchant.status)" clearable>
            <el-option
              v-for="item in actualManagerList"
              :key="item.managerId"
              :label="item.name"
              :value="item.managerId">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="录入人" v-show="merchant.id !== ''">
          <span>{{merchant.keyBoarder}}</span>
        </el-form-item>
        <el-form-item label="录入时间" v-show="merchant.id !== ''">
          <span>{{merchant.createTime}}</span>
        </el-form-item>
        <el-form-item label="添加来源" v-show="merchant.id !== ''">
          <span>{{sourceList.filter(item => {return merchant.source === item.value})[0].text}}</span>
        </el-form-item>
        <el-form-item label="是否需要开卡" label-width="110px" v-show="merchant.id !== ''">
          <span>{{merchant.optType === 0 ? '是' : '否'}}</span>
        </el-form-item>
        <el-form-item label="开卡状态" v-if="merchant.id !== ''">
          <el-select v-model="merchant.status" :disabled="editType === 'info'">
            <el-option v-for="item in statusList" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统校验绑卡时间" label-width="130px" v-show="merchant.id !== ''">
          <span>{{merchant.accountBindTime}}</span>
        </el-form-item>
        <el-form-item label="银行备注" v-if="merchant.id !== '' && merchant.optType !== 10">
          <el-input type="textarea" v-model="merchant.bankRemark" placeholder="请输入银行备注" :disabled="editType === 'info'"></el-input>
        </el-form-item>
        <el-form-item prop="settleBankAccount" label="银行卡号" v-if="merchant.id !== '' && merchant.optType !== 10">
          <el-input v-model="merchant.settleBankAccount" placeholder="请输入银行卡号" :disabled="editType === 'info'"></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info title="添加已绑卡商户提示" :visible.sync="showCheckMerchantDialog"
     @confirm="handleCheckAdd" confirm-text="确认添加" cancel-text="取消添加">
      <div class="check-merchant-view">
        <p class="tips">以下商户地址与报名的银行活动地区范围不匹配，请再次核实清楚商户的地址</p>
        <el-table class="table" border :data="checkMerchantList">
          <el-table-column
            label="商户号"
            prop="merchantId">
          </el-table-column>
          <el-table-column
            label="商户地区"
            prop="merchantAddress">
          </el-table-column>
      </el-table>
      </div>

    </dialog-info>
    <dialog-info title="添加已绑卡商户" :visible.sync="showDirectDialog" :confirmLoading="addDirectLoading" @confirm="addBoundMerchant" @close="clearMerchant">
      <el-tabs v-model="bindFlag">
        <el-tab-pane label="单个添加" name="single"></el-tab-pane>
        <el-tab-pane label="批量添加" name="batch"></el-tab-pane>
      </el-tabs>
      <div v-show="bindFlag === 'batch'">
        <p class="activityName">{{info.activityName}}</p>
        <p class="activityId">活动编号：{{info.activityId}}</p>
        <div class="import-tip">导入须知：请下载批量添加已绑卡商户模板文件，按照模板输入，每次导入不超过3000个</div>
        <el-button  @click="getMultiFiles" size="small" class="import">批量导入</el-button>
        <a href="static/批量添加已绑卡商户模板.xlsx" class="downloadLink">下载模板文件</a>
        <input type="file" ref="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
        <p>仅支持.xls、.xlsx格式</p>
        <el-col v-if="multiFileName !== ''" class="hasSelect">
          <span>已选择: {{ multiFileName }}</span>
          <i class="el-icon-remove removeIcon" @click="removeFile"></i>
        </el-col>
      </div>
      <el-form  v-show="bindFlag === 'single'">
        <el-form-item label="乐刷商户号（必填）">
          <el-input v-model="boundForm.merchantCode" placeholder="请输入商户号"></el-input>
        </el-form-item>
        <el-form-item label="开卡推广员备注（非必填）">
          <el-input type="textarea" v-model.trim="boundForm.remark" placeholder="填入备注信息"  resize="none" :autosize="{minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
        <el-form-item prop="extendedSource" label="拓展来源">
          <el-radio-group v-model="boundForm.extendedSource">
            <el-radio
              v-for="item in extendedSourceList"
              :key="item.value"
              :label="item.value">
              {{item.text}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="补贴对象">
          <el-radio-group v-model="boundForm.settleType">
            <!-- <el-radio
              v-for="item in settleList"
              :key="item.value"
              :label="item.value">
              {{item.text}}
            </el-radio> -->
            <el-radio :key="0" :label="0" v-show="settleType !== 10">补贴给商户</el-radio>
            <el-radio :key="10" :label="10" v-show="settleType !== 0 && info.type === 10">补贴给代理商</el-radio>
          </el-radio-group>
        </el-form-item>
<!--        <el-form-item label="客户经理工号" label-width="100px">-->
<!--          <el-input v-model="boundForm.accountManagerNo" placeholder="请输入商户推荐的银行客户经理工号"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="客户经理姓名" label-width="100px">-->
<!--          <el-input v-model="boundForm.accountManagerName" placeholder="请输入商户推荐的银行客户经理姓名"></el-input>-->
<!--        </el-form-item>-->
        <!-- <el-form-item label="开卡客户经理" prop="actualManagerId">
          <el-select v-model="boundForm.actualManagerId" placeholder="请选择实际开卡的客户经理" style="width: 350px">
            <el-option
              v-for="item in actualManagerList"
              :key="item.managerId"
              :label="item.name"
              :value="item.managerId">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="银行网点（非必填）">
          <el-select v-model="boundForm.cardBankNewId" clearable placeholder="请选择上门开卡的银行网点" @change="handleBindFormaBankChange" ref="cardBankNewId" >
            <el-option
              v-for="item in bankList"
              :key="item.bankNewId"
              :label="item.bankName"
              :value="item.bankNewId">
            </el-option>
          </el-select>
          <!-- <span class="downloadLink" style="margin-left: 12px;" @click="queryAutoBank" v-loading="queryLoading" v-show="editType !== 'state'">系统自动匹配</span> -->
        </el-form-item>
        <el-form-item label="银行网点客户经理（非必填）">
          <el-select v-model="boundForm.managerId" clearable placeholder="请选择银行网点客户经理" >
            <el-option
              v-for="item in managerList"
              :key="item.managerId"
              :label="item.name"
              :value="item.managerId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info :title="exportTitle" :visible.sync="showExportDialog" :confirmLoading="exportLoading" @confirm="exportTrade" confirmText="确定导出" :showConfirmBtn="exportType !== 'info'" :showCancelBtn="exportType !== 'info'" :size="exportType === 'info' ? 'large' : 'small'">
      <div v-if="exportType !== 'info'">
        <p class="timeTitle">选择周期</p>
        <date-range-picker :value="tradeTime" type="daterange" @getChange="getTradeTime" :clearable="true" :disabledAfter="disabledAfter" :maxRange="exportType === 'summery' ? 62 : 31" :disabledBefore="disabledBefore"></date-range-picker>
      </div>
      <div v-if="['summery', 'summeryBank', 'details'].includes(exportType)">
        <div class="inlineSelect">
          <span class="label">周期定义</span>
          <el-radio-group v-model="timeType">
            <el-radio :label="10">【交易】日期</el-radio>
            <el-radio :label="20">【打款】日期</el-radio>
          </el-radio-group>
        </div>
        <p class="info">
          说明：因商户当天的交易，在次日打款到结算银行卡；<br/>
          周期定义为交易日期，则导出周期内的交易数据；<br/>
          周期定义为打款日期，则实际导出整体周期前一天的数据；
        </p>
        <div class="inlineSelect">
          <span class="label">起始时间</span>
          <el-radio-group v-model="startTimeType">
            <el-radio :label="10">以选择周期为准</el-radio>
            <el-radio :label="20">以开始绑卡日期为准</el-radio>
          </el-radio-group>
        </div>
        <p class="info">
          选择以绑卡日期为准，则当选择周期为1号-30号时，若商户在5号绑卡，则导出数据只包含商户5-30号数据；
        </p>
      </div>
      <div class="item" v-if="exportType === 'info' && [0, 1, 2, 4, 6, 9].includes($store.state.userInfo.userType)">
        <div class="flex-space-between title">
          <p class="timeTitle">表头设置</p>
          <auth-button opt="merchant_info_export" label="导出数据" @click.native="exportMerchantInfo"></auth-button>
        </div>
        <div class="row">
          <div class="flex-center btn" :class="{active: item.isSelected}"  v-for="item in quotaHeader" :key="item.code" @click="item.fieldName !== 'merchantId' && (item.isSelected = ! item.isSelected)">
            <span>{{item.fieldHeaderName}}</span>
            <div class="mark">
              <i class="el-icon-check"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="inlineSelect" v-if="exportType === 'withoutAppointment'">
        <p class="info">说明：导出未预约商户时间以录入活动时间为准，导出所选时间内录入活动，未指派银行网点和网点银行经理的商户信息，
          导出内容商户编号、商户地址、开卡状态、开卡服务字段。</p>
      </div>
    </dialog-info>
    <dialog-info title="添加结果" :visible.sync="showResultDialog" @confirm="addResult" :confirmText="hasOtherActivityNum ? '确认切换活动' : '确定'" size="middle" class="addResult">
      <p class="add-info">已成功添加{{successNum}}个商户，以下{{failNum}}个商户添加失败<span v-show="failNum > 10">（最多展示10个，更多可<a @click="jumpDownload" class="downloadLink">下载失败详情文件</a>）</span></p>
      <el-table class="table" border :data="failList">
        <el-table-column
          label="商户编号"
          prop="mcode">
        </el-table-column>
        <el-table-column
          label="店铺名称"
          prop="mname">
        </el-table-column>
        <el-table-column
          label="失败原因"
          prop="errorMsg">
        </el-table-column>
      </el-table>
      <template v-if="hasOtherActivityNum">
        <p style="margin-top: 20px">以下{{ hasOtherActivityNum }}个商户已有正在参与中的活动，请确认是否切换活动<span v-show="hasOtherActivityNum > 10">（最多展示10个，更多可<a @click="jumpDownload" class="downloadLink">下载失败详情文件</a>）</span></p>
        <el-table class="table" border :data="hasOtherActivityList">
          <el-table-column
            label="商户编号"
            prop="mcode">
          </el-table-column>
          <el-table-column
            label="店铺名称"
            prop="mname">
          </el-table-column>
          <el-table-column
            label="温馨提示"
            prop="errorMsg">
          </el-table-column>
        </el-table>
      </template>
    </dialog-info>
    <dialog-info title="开卡状态" :visible.sync="showBindRecordDialog" size="large" :show="true" :showCancelBtn="false" footerAlign="center" @confirm="openCardDialogConfirm" >
      <el-tabs type="card" v-model="openCardTab"  @tab-click="handleOpenCardTabClick">
        <el-tab-pane label="开卡状态变更" name="updateOpenState">
          <el-form>
            <el-form-item label="开卡状态">
              <el-select v-model="openCardUpdateForm.status" :disabled="clickedJoinState!==0">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                  :disabled="[30,40].includes(clickedOpenCardStatus)&&![0,30,40].includes(item.value)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="开卡状态变更记录" name="viewUpdateRecords">
          <el-table border :data="bindRecordList" v-loading="bindRecordLoading">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column
              prop="updateTime"
              label="时间">
            </el-table-column>
            <el-table-column
              prop="status"
              label="开卡状态">
              <template slot-scope="scope">
                <span>{{getListText(scope.row.status, statusList)}}</span>
             </template>
            </el-table-column>
          </el-table>
          <pagination
            :count="bindPagination.total"
            :page-no="bindPagination.pageNo"
            :size="bindPagination.pageSize"
            @changePage="value => { bindPagination.pageNo = value;getBindRecordList() }"
            @changeSize="value => { bindPagination.pageSize = value;bindPagination.pageNo = 1;getBindRecordList() }"
          ></pagination>
        </el-tab-pane>
      </el-tabs>
      <!-- <div class="title-bold">开卡状态变更</div> -->

      <!-- <div class="title-bold">开卡状态变更记录</div> -->
    </dialog-info>
    <!-- 批量开卡指派 -->
    <dialog-info
      :visible.sync="showBatchAssignDialog"
      title="批量开卡指派"
      @confirm="batchAssign"
      @close="resetBatchAssign"
      :confirmLoading="batchAddLoading"
    >
      <p class="DialogText">导入须知：</p>
      <p class="DialogText">（1）请下载批量开卡指派模板，按照模板输入，每次不超过500个商户</p>
      <p style="margin-bottom: 6px" class="DialogText">（2）只允许变更此银行活动下的商户，以及更改的银行网点，银行网点客户经理，开卡客户经理必须是银行活动管理银行</p>
      <el-button @click="getMultiFiles" size="small" class="import" type="primary" style="padding: 8px 20px; border-radius: 5px">批量导入</el-button>
      <a href="static/批量开卡指派模板.xlsx" class="downloadLink">下载模板文件</a>
      <p>仅支持.xls、.xlsx格式</p>
      <el-col v-if="multiFileName !== ''" class="hasSelect" style="margin: 10px 0">
        <span>已选择: {{ multiFileName }}</span>
        <i class="el-icon-remove removeIcon" @click="removeFile"></i>
      </el-col>
      <input type="file" ref="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vndms-excel"/>
    </dialog-info>

    <dialog-info title="批量开卡指派结果" :visible.sync="showAssignResultDialog" @confirm="() => showAssignResultDialog = false" confirmText="确定" size="middle" class="addResult">
      <p class="add-info">已成功变更{{successNum}}个商户，以下{{failNum}}个商户变更失败<span v-show="failNum > 10">（最多展示10个，更多可<a @click="jumpDownload" class="downloadLink">下载失败详情文件</a>）</span></p>
      <el-table class="table" border :data="failList">
        <el-table-column
          label="商户编号"
          prop="merchantId">
        </el-table-column>
        <el-table-column
          label="失败原因"
          prop="errorMsg">
        </el-table-column>
      </el-table>
    </dialog-info>
    <!-- 开卡指派弹框 -->
    <dialog-info title="开卡指派" :visible.sync="showOpenCardDialog" footerAlign="center" size="large" :show="true" :showCancelBtn="false" @confirm="openCardAssignConfirm">
      <el-tabs type="card" v-model="openAssignFlag" @tab-click="handleOpenAssignTabClick">
        <el-tab-pane label="开卡指派" name="updateOpenAssign" >
          <el-form :model="assignmentForm">
            <el-form-item label="银行网点">
              <el-select v-model="assignmentForm.cardBankNewId" clearable @change="handleAssignmentBankChange">
                <el-option
                  v-for="item in bankList"
                  :key="item.bankNewId"
                  :label="item.bankName"
                  :value="item.bankNewId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="网点银行经理">
              <el-select v-model="assignmentForm.managerId" clearable>
                <el-option
                  v-for="item in assignmentManagerList"
                  :key="item.managerId"
                  :label="item.name"
                  :value="item.managerId"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="开卡指派变更记录" name="viewOpenAssignRecords">
          <el-table border :data="openCardList" v-loading="openCardLoading">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="时间">
            </el-table-column>
            <el-table-column
              prop="bankName"
              label="银行网点">
            </el-table-column>
            <el-table-column
              prop="managerName"
              label="网点银行经理">
            </el-table-column>
          </el-table>
          <pagination
            :count="assignPagination.total"
            :page-no="assignPagination.pageNo"
            :size="assignPagination.pageSize"
            @changePage="value => { assignPagination.pageNo = value;getOpenCardAssign() }"
            @changeSize="value => { assignPagination.pageSize = value;assignPagination.pageNo = 1;getOpenCardAssign() }"
          ></pagination>
        </el-tab-pane>
      </el-tabs>
    </dialog-info>
    <!-- 添加单个商户报名二次确认 -->
    <el-dialog
      title="提示"
      :visible.sync="addSingleMerchantDialog"
      width="300px"
      :show-close="false"
      :close-on-click-modal="false"
      center>
      <span>商户有{{ otherActivityNo }}正在参与中，是否退出原活动参与新活动？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addSingleMerchantDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddMerchant">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加单个商户报名-失败 -->
    <el-dialog
      title="提示"
      :visible.sync="addSingleMerchantFailDialog"
      width="300px"
      :show-close="false"
      :close-on-click-modal="false"
      center>
      <span>{{ addSingleMerchantFailReason }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSingleMerchantFailDialog = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dialogInfo from '@/components/layout/dialogInfo'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import addressSelect from '@/components/addressSelect'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { downJumpConfirm, createDownLink } from '@/assets/js/utils'
import batchImport from '@/components/upload/batchImport'
export default {
  name: 'subsidyMerchant',
  components: {
    dateRangePicker,
    pagination,
    dialogInfo,
    addressSelect,
    uploadImgEle,
    batchImport
  },
  data () {
    return {
      openCardTab: 'updateOpenState',
      openAssignFlag: 'updateOpenAssign',
      bankAccountList: [], // 银行卡号显示隐藏
      showCheckMerchantDialog: false,
      checkMerchantList: [],
      checkType: 1,
      disabledAfter: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00:00`).getTime() - 1000,
      disabledBefore: new Date().setMonth(new Date().getMonth() - 12),
      searchLoading: false,
      info: {
        activityId: '',
        activityName: '',
        type: '', // 活动类型 10 月返 20 实时返 30 非0实时返
        subType: '', // 0不提供，10上门开卡，20邮政
        openCardDemand: '', // 开卡要求
        bankCode: ''
      },
      merchantList: [],
      actualManagerList: [],
      searchForm: {
        merchantId: '',
        agentId: '',
        settleName: '',
        status: '',
        pageNo: 1,
        pageSize: 10,
        enterTimeStart: '',
        enterTimeEnd: '',
        updateTimeStart: '',
        updateTimeEnd: '',
        extendedSource: '',
        source: '',
        bindCardTimeStart: '',
        bindCardTimeEnd: '',
        joinState: ''
      },
      inputTime: [],
      updateTime: [],
      statusList: [{
        text: '未预约',
        value: 10
      }, {
        text: '已指派',
        value: 50
      }, {
        text: '已预约',
        value: 20
      }, {
        text: '已开卡',
        value: 30
      }, {
        text: '已绑卡',
        value: 40
      }, {
        text: '无效',
        value: 0
      }],
      sourceList: [
        {
          text: '小程序添加',
          value: 0
        }, {
          text: '后台录入',
          value: 10
        }, {
          text: '商户端h5',
          value: 20
        }, {
          text: '系统自动录入',
          value: 30
        }, {
          text: '外放接口',
          value: 50
        }, {
          text: '联拓',
          value: 60
        }, {
          text: '联合收单App',
          value: 70
        }
      ],
      extendedSourceList: [
        {
          text: '银行推荐',
          value: 10
        }, {
          text: '其他',
          value: 0
        }
      ],
      total: 1,
      showDialog: false,
      editLoading: false,
      merchant: {
        id: '',
        merchantCode: '',
        settleName: '',
        mobile: '',
        baseMobile: '',
        shopName: '',
        actualManagerId: '',
        mobileType: 1, // 0=商户表中的手机， 1=新增手机号
        address: {
          address: '',
          provinceName: '',
          provinceNo: '',
          cityName: '',
          cityNo: '',
          areaName: '',
          areaNo: ''
        },
        remark: '',
        // marketerName: '', // 推广员
        // marketerMobile: '', // 推广员
        status: '',
        bankRemark: '',
        settleBankAccount: '',
        source: 0, // 来源0=小程序添加 10=后台录入 20=商户端h5 30=系统自动录入 50=外放接口
        optType: 0, // 0=需要上门开卡， 10=不需上门开卡 30-网点开卡
        createTime: '', // 录入时间
        inputName: '', // 录入人
        accountBindTime: '', // 系统校验绑卡时间
        extendedSource: 0, // 拓展来源 10 银行推荐 0 其他
        idCardNo: '', // 身份证号
        idCardFront: '', // 身份证头像面
        idCardBack: '', // 身份证国徽面
        settleType: '', // 补贴对象 默认不选择
        cardBankNewId: '',
        managerId: '',
        // accountManagerNo: '', // 客户经理工号
        // accountManagerName: '', // 客户经理姓名
        openCardDemand: ''
      },
      ruleData: {
        merchantCode: [
          { message: '请输入乐刷商户号', required: true, trigger: 'blur' },
          { pattern: /^\d{10,64}$/, message: '请输入数字商户编号', trigger: 'blur' }
        ],
        settleName: [
          { required: true, message: '请输入结算人/开户人', trigger: 'blur' },
          { pattern: /^\S{2,20}$/, message: '请输入2-20位非空结算人/开户人', trigger: 'blur' }
        ],
        mobile: [{
          validator: (rule, value, callback) => {
            // !/^\d{3}\*{4}\d{4}$/.test(value)
            if (!(/\*|^\d{11,11}$/.test(value)) && this.merchant.mobileType === 1) {
              callback(new Error('请输入11位手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        shopName: [{
          validator: (rule, value, callback) => {
            if (this.editType === 'state' || this.merchant.optType === 10) {
              callback()
            } else if (!value) {
              callback(new Error('请输入店铺名称'))
            } else if (!(/^[a-zA-Z0-9\u4E00-\u9FA5]{2,20}$/.test(value))) {
              callback(new Error('请输入2-20位正确店铺名称'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        settleBankAccount: [{
          validator: (rule, value, callback) => {
            if (value && !(/^\d{16,19}$/.test(value))) {
              callback(new Error('请输入正确银行卡号'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        idCardNo: [{
          validator: (rule, value, callback) => {
            if (this.info.subType === 20 && value && !(/(^[\d]{15}$)|(^[\d]{18}$)|(^[\d]{17}(\d|X|x)$)/.test(value))) {
              callback(new Error('请输入正确的身份证号'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        settleType: [{
          validator: (rule, value, callback) => {
            if (this.settleList.filter(item => item.value === value).length === 0) {
              callback(new Error('请选择补贴对象'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        address: [{
          required: true,
          validator: (rule, value, callback) => {
            callback()
          }
        }]
      },
      showDirectDialog: false,
      addDirectLoading: false, // 添加已绑卡商户加载
      exportTitle: '',
      showExportDialog: false,
      exportLoading: false,
      exportType: '', // 导出类型summery:交易汇总,details:交易明细,summeryBank:银行交易汇总 info: 商户资料,withoutAppointment:未预约商户
      tradeTime: [],
      tradeTimeStart: '',
      tradeTimeEnd: '',
      checkLoading: false,
      boundForm: {
        merchantCode: '',
        remark: '',
        extendedSource: 0, // 10 银行推荐 0 其他
        settleType: '', // 补贴对象 无默认值 必填
        // accountManagerNo: '', // 客户经理工号
        // accountManagerName: '' // 客户经理姓名
        actualManagerId: ''
      },
      idcardFront_eg: require('@/assets/image/id2.png'), // 示例图片
      idcardBack_eg: require('@/assets/image/id1.png'), // 示例图片
      settleList: [
        {
          text: '补贴给代理商',
          value: 10
        }, {
          text: '补贴给商户',
          value: 0
        }
      ],
      editType: 'info',
      timeType: 10, // 周期定义 10：交易日期, 20：打款日期
      startTimeType: 10, // 起始时间 10：选择周期,20: 开始绑卡时间
      showResultDialog: false, // 批量添加返回结果对话框
      showAssignResultDialog: false, // 批量指派添加结果
      failMerchants: [],
      successNum: 0, // 批量添加成功数量
      failNum: 0, // 批量添加失败数量
      failList: [],
      quotaHeader: [],
      bankList: [],
      managerList: [],
      queryLoading: false,
      bindPagination: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      assignPagination: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      bindRecordList: [],
      openCardList: [],
      bindMerchantId: '',
      bindAssignId: '',
      showBindRecordDialog: false,
      bindRecordLoading: false,
      openCardLoading: false,
      merchantFlag: 'single', // 新增待开卡商户
      bindFlag: 'single', // 已绑卡商户
      multiFile: '',
      multiFileName: '',
      bindTime: [],
      openCardDemandList: [],
      settleType: '', // 补贴对象
      showBatchAssignDialog: false,
      showOpenCardDialog: false,
      openCardUpdateForm: {
        status: ''
      },
      isCheckDetail: true,
      batchAddLoading: false,
      assignmentForm: {
        managerId: '',
        cardBankNewId: ''
      },
      assignmentManagerList: [],
      clickedId: '',
      clickedJoinState: '',
      clickedOpenCardStatus: '',
      hasOtherActivityNum: 0, // 批量添加返回的参数
      hasOtherActivityList: [],
      addSingleMerchantDialog: false,
      addSingleMerchantFailDialog: false, // 不可为商户添加活动的对话框
      addSingleMerchantFailReason: '',
      otherActivityNo: '', // 商户正在参与的其他活动编号
      isAddBoundMerchant: true // true：是添加已绑卡商户；false：是录入待开卡商户
    }
  },
  mounted () {
    this.searchForm.merchantId = this.$route.params.merchantId
    this.searchForm.agentId = this.$route.params.agentId
    this.info.activityId = this.$route.query.id
    this.info.activityName = this.$route.query.name
    this.info.type = parseInt(this.$route.query.type)
    this.info.subType = parseInt(this.$route.query.subType)
    this.info.openCardDemand = parseInt(this.$route.query.openCardDemand)
    this.info.bankCode = this.$route.query.bankCode
    if (!this.hasData(this.$route.query)) {
      this.info = JSON.parse(localStorage.getItem('subsidyInfo'))
    } else {
      localStorage.setItem('subsidyInfo', JSON.stringify(this.info))
    }
    this.init()
  },
  activated () {
    if (!this.hasData(this.$route.query)) {
      if (!this.hasData(this.info)) {
        this.info = JSON.stringify(localStorage.getItem('subsidyInfo'))
        this.init()
      }
    } else {
      if (this.info.activityId !== this.$route.query.id || this.info.activityName !== this.$route.query.name || this.info.type !== parseInt(this.$route.query.type) || this.info.subType !== parseInt(this.$route.query.type)) {
        this.info.activityId = this.$route.query.id
        this.info.activityName = this.$route.query.name
        this.info.type = parseInt(this.$route.query.type)
        this.info.subType = parseInt(this.$route.query.subType)
        this.info.openCardDemand = parseInt(this.$route.query.openCardDemand)
        this.info.bankCode = this.$route.query.bankCode
        localStorage.setItem('subsidyInfo', JSON.stringify(this.info))
        this.searchForm.merchantId = this.$route.params.merchantId
        this.searchForm.agentId = this.$route.params.agentId
        this.init()
      }
    }
  },
  methods: {
    confirmAddMerchant () {
      this.addSingleMerchantDialog = false
      // 根据是录入待开卡还是添加已绑卡来判断添加的类型
      if (this.isAddBoundMerchant) {
        this.addBindCardMerchant()
      } else {
        this.addSingleMerchant()
      }
    },
    // 点击确定或确认切换活动的回调
    addResult () {
      this.showResultDialog = false
      // 是否是批量录入或者没有商户在参与其他活动
      if (!this.hasOtherActivityNum) {
        return false
      }
      // 确认切换
      const data = new FormData()
      data.append('activityId', this.info.activityId)
      data.append('multipartFile', this.multiFile)
      let apiKey = 'subsidyBatchAddUnBoundMerchant'
      if (this.isAddBoundMerchant) {
        apiKey = 'subsidyBatchAddBoundMerchant'
      }
      this.$axios.post(this.$api[apiKey], data).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '已成功添加' + res.data.successCount + '个商户',
            showClose: true
          })
          this.multiFile = null
          this.searchForm.pageNo = 1
          this.getMerchantList()
        }
      })
    },
    exitActivityRequest (id) {
      this.$axios.post(this.$api.exitActivity, { id }).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.getMerchantList() // 刷新列表
        }
      })
    },
    doExitActivity (row) {
      this.$confirm(`<div>商户是否退出${this.info.activityName}活动？</div><p style="font-size:12px">注：商户退出活动后补贴状态关闭；</p>`, '退出活动', {
        type: 'warning',
        confirmButtonText: '确认退出',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.exitActivityRequest(row.id)
      })
    },
    showBankCard (row) {
      console.log(row)
      if (this.bankAccountList.indexOf(row.merchantId) === -1) {
        this.bankAccountList.push(row.merchantId)
      } else {
        this.bankAccountList.forEach((item, index) => {
          if (item === row.merchantId) {
            this.bankAccountList.splice(index, 1)
          }
        })
      }
    },
    async init () {
      this.getManagerByBankCode()
      this.getBankByMerchantId()
      await this.getMerchantList()
      this.getExportHead()
      // 获取活动的补贴对象
      this.$axios.post(this.$api.activityList, { activityId: this.$route.query.id }).then(res => {
        if (res.respCode === '0') {
          // 判断创建活动时是否有选择补贴对象
          res.data.list[0].settleType !== '' ? this.settleType = res.data.list[0].settleType.split(',').map(Number) : this.settleType = res.data.list[0].settleType
          // 只选择了一个补贴对象
          if (this.settleType.length === 1) {
            this.settleType = this.settleType[0]
          }
        }
      })
    },
    async getManagerByBankCode () {
      this.$axios.post(this.$api.queryManagerList, { bankCode: this.info.bankCode }).then(res => {
        if (res.respCode === '0') {
          this.actualManagerList = res.data
          // .map(item => {
          //   item.label = `${item.name} ${item.phone} ${item.managerNo} `
          //   return item
          // })
        }
      })
    },
    // 商户管理表格数据
    getMerchantList () {
      this.getSearchDate()
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId,
        merchantId: this.searchForm.merchantId,
        agentId: this.searchForm.agentId,
        status: this.searchForm.status.join(',')
      })
      this.searchLoading = true
      return new Promise((resolve, reject) => {
        this.$axios.post(this.$api.merchantList, params).then(res => {
          this.searchLoading = false
          if (res.respCode === '0') {
            this.merchantList = res.data.list
            this.total = res.data.count
          }
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    },
    search () {
      this.searchForm.pageNo = 1
      this.getMerchantList()
    },
    /**
     * @description 店铺地址选中回调
     * @param {Object} val 组件传的参数，店铺地址数据
     */
    getAddress (val) {
      this.merchant.address = val
    },
    /**
     * @description 录入待开卡商户
     */
    toAddUnbound () {
      this.isAddBoundMerchant = false
      this.merchant = this.$options.data().merchant
      if (this.info.type !== 10) {
        this.merchant.settleType = 0
      }
      typeof this.settleType === 'object' || this.settleType === '' ? this.merchant.settleType = 0 : this.merchant.settleType = this.settleType
      this.merchant.optType = this.info.subType === 30 ? 30 : 0
      this.isCheckDetail = false
      this.showDialog = true
      const that = this
      setTimeout(function () {
        that.$refs.merchant.clearValidate()
        that.$refs.addressSelectForm.$refs.form.clearValidate()
      }, 100)
    },
    /**
     * @description 查看详情
     */
    checkDetails (row) {
      this.$router.push({
        name: 'merchantInfo',
        query: {
          activityName: this.info.activityName,
          activityId: this.info.activityId,
          merchantId: row.merchantCode,
          id: row.id,
          optType: row.optType,
          joinState: row.joinState,
          exitTime: row.exitTime,
          activityType: this.info.type,
          openCardStatus: row.status
        }
      })
      // this.merchant = row
      // this.merchant = JSON.parse(JSON.stringify(row))
      // let currentValue = this.merchant.openCardDemand;
      // [10, 1].forEach(item => {
      //   if (currentValue >= item) {
      //     this.openCardDemandList.push(item)
      //     currentValue -= item
      //   }
      // })
      // if (!this.merchant.address) {
      //   this.merchant.address = this.$options.data().merchant.address
      // }
      // this.merchant.mobile = row.mobileType === 1 ? row.mobile : ''
      // if (this.merchant.cardBankNewId) {
      //   this.handleBankChange(this.merchant.cardBankNewId, false)
      // }
      // this.isCheckDetail = true
      // this.showDialog = true
      // const that = this
      // setTimeout(function () {
      //   that.$refs.merchant.clearValidate()
      //   // 需要上门开卡的才有地址
      //   if (!row.optType) {
      //     that.$refs.addressSelectForm.$refs.form.clearValidate()
      //   }
      // }, 100)
    },
    /**
     * @description 点击添加已绑卡商户
     */
    toAddBound () {
      this.isAddBoundMerchant = true
      this.boundForm = this.$options.data().boundForm
      if (this.info.type !== 10) {
        this.boundForm.settleType = 0
      }
      if (typeof this.settleType === 'object' || this.settleType === '') {
        this.boundForm.settleType = 0
      } else {
        this.boundForm.settleType = this.settleType
      }
      if (!this.actualManagerList.length) {
        this.getManagerByBankCode()
      }
      this.showDirectDialog = true
    },
    /**
     * @description 编辑商户
     */
    editMerchant (row, type) {
      this.merchant = JSON.parse(JSON.stringify(row))
      let currentValue = this.merchant.openCardDemand;
      [10, 1].forEach(item => {
        if (currentValue >= item) {
          this.openCardDemandList.push(item)
          currentValue -= item
        }
      })
      this.merchant.mobile = row.mobileType === 1 ? row.mobile : ''
      if (this.merchant.cardBankNewId) {
        this.handleBankChange(this.merchant.cardBankNewId, false)
      }
      this.isCheckDetail = false
      this.editType = type
      this.showDialog = true
      const that = this
      setTimeout(function () {
        that.$refs.merchant.clearValidate()
        !that.merchant.optType && that.$refs.addressSelectForm.$refs.form.clearValidate()
      }, 100)
    },
    /**
     * @description 根据id查询乐刷商户信息
     */
    getMerchantInfo () {
      if (!/^\d{10,64}$/.test(this.merchant.merchantCode)) {
        this.$message({
          type: 'error',
          message: '商户号不可带有空格或特殊格式，只能输入数字！'
        })
        return
      }
      this.checkLoading = true
      this.$axios.post(this.$api.getMerchantBase, {
        merchantCode: this.merchant.merchantCode
      }).then(res => {
        this.checkLoading = false
        if (res.respCode === '0') {
          const data = res.data
          this.merchant.baseMobile = data.mobile
          this.merchant.mobileType = data.mobile ? 0 : 1
          this.merchant.settleName = data.settleName
          this.merchant.shopName = data.shopName
          this.merchant.address = data.merchantAddress
        }
      })
    },
    /**
     * @description 提交编辑或新增商户
     */
    addSingleMerchant () {
      const apiUrl = this.merchant.id ? (this.merchant.optType !== 10 ? 'editMerchant' : 'editBindMerchant') : 'addMerchant'
      const msg = this.merchant.id ? '编辑成功' : '新增成功'
      this.editLoading = true
      const params = this.merchant.optType !== 10 ? Object.assign({}, this.merchant, {
        activityId: this.info.activityId
      }) : {
        id: this.merchant.id,
        remark: this.merchant.remark,
        extendedSource: this.merchant.extendedSource,
        settleType: this.merchant.settleType
        // actualManagerId: this.merchant.actualManagerId
        // accountManagerNo: this.merchant.accountManagerNo,
        // accountManagerName: this.merchant.accountManagerName
      }
      // params.cardBankNewId = params.managerId ? params.cardBankNewId : ''
      // params.settleType = this.info.type === 10 ? params.settleType : 0
      params.openCardDemand = this.openCardDemandList.reduce((a, b) => a + b, 0)
      this.$axios.post(this.$api[apiUrl], params).then(res => {
        this.editLoading = false
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: msg
          })
          this.showDialog = false
          this.getMerchantList()
        }
      })
    },
    submitMerchant () {
      if (this.merchantFlag === 'batch') {
        if (this.multiFile === '') {
          this.$message({
            message: '请先上传文件',
            type: 'warning'
          })
          return
        }
        this.editLoading = true
        const data = new FormData()
        data.append('activityId', this.info.activityId)
        data.append('multipartFile', this.multiFile)
        this.$axios.post(this.$api.batchAddMerchant, data).then((res) => {
          this.editLoading = false
          if (res.respCode === '0') {
            if ((res.data && res.data.failMerchants && res.data.failMerchants.length > 0) ||
              res.data.switchCount > 0) {
              this.failMerchants = res.data.failMerchants.join(', ')
              this.successNum = res.data.successCount
              this.failNum = res.data.failCount
              this.failList = res.data.failMerchants
              this.showDialog = false
              this.hasOtherActivityNum = res.data.switchCount
              this.hasOtherActivityList = res.data.switchActivityMerchants
              this.showResultDialog = true
              this.searchForm.pageNo = 1
              this.getMerchantList()
            } else {
              this.$message({
                type: 'success',
                message: res.respMsg + '，成功新增' + res.data.successCount + '条',
                showClose: true
              })
              this.searchForm.pageNo = 1
              this.getMerchantList()
              this.showDialog = false
            }
          }
        })
      } else {
        let merchantValid = false
        let addressSelectFormValid = false
        this.$refs.merchant.validate((valid, error) => {
          console.log(valid, error)
          merchantValid = valid
        })
        if (this.merchant.optType !== 10) {
          this.$refs.addressSelectForm.$refs.form.validate((valid, error) => {
            console.log(valid, error)
            addressSelectFormValid = valid
          })
        }
        if (merchantValid && ((this.merchant.optType !== 10 && addressSelectFormValid) || this.merchant.optType)) {
          // 校验通过
          this.$confirm('是否确认提交？', '温馨提醒').then(() => {
            // 确认提交前，先判断待添加的商户是否能加入该活动或者是否需要二次弹窗确认。
            const checkParams = {
              merchantCode: this.merchant.merchantCode,
              activityId: this.info.activityId
            }
            this.$axios.post(this.$api.addMerchantCheck, checkParams).then(res => {
              if (res.respCode !== '0') {
                // 不可参与活动
                this.addSingleMerchantFailDialog = true
                this.addSingleMerchantFailReason = res.respMsg
                this.$message.closeAll()
                return true
              }
              // 是切换活动
              if (res.data.switchActivity === 1) {
                this.addSingleMerchantDialog = true
                this.otherActivityNo = res.data.currentJoinActivity
                return true
              }
              // 不是切换活动，再添加商户
              this.addSingleMerchant()
            })
          }).catch(() => {
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      }
    },
    /**
     * @description 添加已绑卡商户提交
     */
    addBoundMerchant () {
      if (this.bindFlag === 'batch') {
        if (this.multiFile === '') {
          this.$message({
            message: '请先上传文件',
            type: 'warning'
          })
          return
        }
        this.addDirectLoading = true
        const data = new FormData()
        data.append('activityId', this.info.activityId)
        data.append('multipartFile', this.multiFile)
        this.checkBatchMerchantInfo(data)
      } else {
        const merchantId = this.boundForm.merchantCode.replace(/[,\n]+/g, ',')
        // 校验商户id格式是否正确
        if (merchantId && /^\d+$/.test(merchantId) && this.settleList.filter(item => item.value === this.boundForm.settleType).length >= 1) {
          // 校验通过
          // this.addBindCardMerchant(merchantId)
          this.checkMerchantInfo(merchantId)
        } else if (/^\s$/.test(this.boundForm.merchantCode)) {
          this.$message({
            type: 'warning',
            message: '商户号不可带有空格或特殊格式！'
          })
        } else if (this.settleList.filter(item => item.value === this.boundForm.settleType).length === 0) {
          this.$message({
            type: 'warning',
            message: '请选择补贴对象'
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请输入正确商户号'
          })
        }
      }
    },
    /**
     * 校验录入商户信息
     */
    checkMerchantInfo () {
      this.checkType = 1
      const merchantId = this.boundForm.merchantCode.replace(/[,\n]+/g, ',')
      const params = {
        merchantCode: merchantId,
        activityId: this.info.activityId
      }
      this.$axios.post(this.$api.bindCheckMerchant, params).then(res => {
        if (res.respCode !== '0') {
          this.addSingleMerchantFailDialog = true
          this.addSingleMerchantFailReason = res.respMsg
          this.$message.closeAll()
          return true
        }
        const { isJust, merchantAddress, merchantId } = res.data
        if (isJust === 1) { // 匹配
          // 匹配之后，还需判断是否切换活动。未切换，则直接添加，否则，先弹窗。
          if (res.data.switchActivity === 1) {
            this.addSingleMerchantDialog = true
            this.otherActivityNo = res.data.currentJoinActivity
            return true
          }
          this.addBindCardMerchant()
        } else if (isJust === 2) { // 不匹配
          this.checkMerchantList = [{ merchantId, merchantAddress }]
          this.checkNotJust()
        }
      })
    },
    checkBatchMerchantInfo (data) {
      this.checkType = 2
      this.$axios.post(this.$api.bindCheckBatchMerchant, data).then(res => {
        if (res.respCode === '0') {
          const list = res.data
          if (!list.length) { // 匹配
            this.addBindBatchMerchant(data)
          } else { // 不匹配
            this.checkMerchantList = list
            this.checkNotJust()
          }
        } else {
          this.addDirectLoading = false
        }
      })
    },
    /**
     * 校验录入商户信息不匹配的情况
     */
    checkNotJust () {
      // this.showDirectDialog = false
      this.addDirectLoading = false
      this.showCheckMerchantDialog = true
    },
    handleCheckAdd () {
      this.showCheckMerchantDialog = false
      if (this.checkType === 1) {
        this.addBindCardMerchant()
      } else {
        const data = new FormData()
        data.append('activityId', this.info.activityId)
        data.append('multipartFile', this.multiFile)
        this.addBindBatchMerchant(data)
      }
    },
    /**
     * 批量添加已绑卡商户
     */
    addBindBatchMerchant (data) {
      this.$axios.post(this.$api.batchAddBoundMerchant, data).then((res) => {
        this.addDirectLoading = false
        if (res.respCode === '0') {
          if ((res.data && res.data.failMerchants && res.data.failMerchants.length > 0) ||
            res.data.switchCount > 0) {
            this.failMerchants = res.data.failMerchants.join(', ')
            this.successNum = res.data.successCount
            this.failNum = res.data.failCount
            this.failList = res.data.failMerchants
            this.showDirectDialog = false
            this.hasOtherActivityNum = res.data.switchCount
            this.hasOtherActivityList = res.data.switchActivityMerchants
            this.showResultDialog = true
            this.searchForm.pageNo = 1
            this.getMerchantList()
          } else {
            this.$message({
              type: 'success',
              message: res.respMsg + '，成功新增' + res.data.successCount + '条',
              showClose: true
            })
            this.searchForm.pageNo = 1
            this.getMerchantList()
            this.showDirectDialog = false
          }
        }
      })
    },
    /**
     * 添加已绑卡商户
     */
    addBindCardMerchant () {
      if (this.addDirectLoading) {
        return
      }
      const merchantId = this.boundForm.merchantCode.replace(/[,\n]+/g, ',')
      this.addDirectLoading = true
      const params = JSON.parse(JSON.stringify(Object.assign({}, this.boundForm, {
        activityId: this.info.activityId
      })))
      params.merchantId = merchantId
      this.$axios.post(this.$api.addBatch, params).then(res => {
        this.addDirectLoading = false
        if (res.respCode === '0') {
          if (res.data && res.data.failMerchants && res.data.failMerchants.length > 0) {
            // this.$message({
            //   type: 'success',
            //   message: '成功添加已绑卡商户（说明：商户能否获得奖励以银行核实结果为准）'
            // })
            this.failMerchants = res.data.failMerchants.join(', ')
            this.successNum = res.data.successCount
            this.failNum = res.data.failCount
            this.failList = res.data.failMerchants
            this.showDirectDialog = false
            // 添加单个商户时，不展示正在参与的其他活动
            this.hasOtherActivityNum = 0
            this.hasOtherActivityList = []
            this.showResultDialog = true
            this.searchForm.pageNo = 1
            this.getMerchantList()
          } else {
            this.$message({
              type: 'success',
              message: '成功添加已绑卡商户（说明：商户能否获得奖励以银行核实结果为准）'
            })
            this.searchForm.pageNo = 1
            this.getMerchantList()
            this.showDirectDialog = false
          }
        }
      })
    },
    /**
     * @description 导出已绑卡【商户资料】
     */
    toExportInfo () {
      if (![0, 1, 2, 4, 6, 9].includes(this.$store.state.userInfo.userType)) {
        const that = this
        this.getSearchDate()
        const params = Object.assign({}, this.searchForm, {
          activityId: this.info.activityId,
          status: this.searchForm.status.join(',')
        })
        this.$confirm('确定导出 【已绑卡】的商户资料?', '温馨提醒', {
          confirmButtonText: '确定导出'
        }).then(() => {
        // 确定导出
          that.$axios.post(that.$api.exportInfo, params).then(res => {
            if (res.respCode === '0') {
              downJumpConfirm.call(that)
            }
          })
        }).catch(() => {
        })
      } else {
        this.exportTitle = '导出已绑卡【商户资料】'
        this.exportType = 'info'
        this.tradeTime = []
        this.tradeTimeStart = ''
        this.tradeTimeEnd = ''
        this.showExportDialog = true
      }
    },
    /**
     * @description 点击导出已绑卡商户【交易汇总】按钮
     */
    toExportSummery () {
      this.exportTitle = '导出已绑卡商户【交易汇总】'
      this.exportType = 'summery'
      this.tradeTime = []
      this.tradeTimeStart = ''
      this.tradeTimeEnd = ''
      this.showExportDialog = true
    },
    /**
     * @description 点击导出已绑卡商户【交易明细】按钮
     */
    toExportDetails () {
      this.exportTitle = '导出已绑卡商户【交易明细】'
      this.exportType = 'details'
      this.tradeTime = []
      this.tradeTimeStart = ''
      this.tradeTimeEnd = ''
      this.showExportDialog = true
    },
    /**
     * @description 导出交易起止时间
     * @params {Array} value 选中时间数组
     */
    getTradeTime (value) {
      if (value && value.length !== 0) {
        this.tradeTimeStart = value[0] + ' 00:00:00'
        this.tradeTimeEnd = value[1] + ' 23:59:59'
        this.tradeTime = [this.tradeTimeStart, this.tradeTimeEnd]
      } else {
        this.tradeTimeStart = ''
        this.tradeTimeEnd = ''
        this.tradeTime = []
      }
    },
    exportMerchant () {
      if (this.exportLoading) {
        return
      }
      this.exportLoading = true
      this.getSearchDate()
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId,
        status: this.searchForm.status.join(',')
      })
      this.$axios.post(this.$api.exportMerchant, params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
        this.exportLoading = false
      })
    },
    /**
     * @description 导出已绑卡商户【交易明细】或者 【交易汇总】或者交易汇总（银行）
     */
    exportTrade () {
      if (this.tradeTimeStart === '' || this.tradeTimeEnd === '') {
        this.$message({
          type: 'warning',
          message: '请选择完整导出时间！'
        })
        return
      }
      if (this.exportType === 'summery' && this.tradeTimeStart === '') {
        this.$message({
          type: 'warning',
          message: '请选择周期定义起始时间'
        })
        return
      }
      if (this.exportLoading) {
        return true
      }
      // 根据exportType导出不同数据
      this.exportLoading = true
      let api = this.exportType === 'details'
        ? 'exportTradeDetail'
        : this.exportType === 'summery' ? 'exportTradeSummary' : 'exportTradeSummaryBank'
      if (this.exportType === 'withoutAppointment') {
        api = 'exportUnappointed'
      }
      // this.$message({
      //   type: 'info',
      //   message: '导出中，请稍候...'
      // })
      this.getSearchDate()
      const mergeParams = {
        tradeTimeStart: this.tradeTimeStart,
        tradeTimeEnd: this.tradeTimeEnd,
        activityId: this.info.activityId,
        status: this.searchForm.status.join(',')
      }
      if (['summery', 'summeryBank', 'details'].includes(this.exportType)) {
        mergeParams.timeType = this.timeType
        mergeParams.startTimeType = this.startTimeType
      }
      let params = Object.assign({}, this.searchForm, mergeParams)
      if (this.exportType === 'withoutAppointment') {
        params = {
          activityId: this.info.activityId,
          startDate: this.tradeTimeStart,
          endDate: this.tradeTimeEnd
        }
      }
      this.$axios.post(this.$api[api], params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
        this.exportLoading = false
        this.tradeTimeStart = ''
        this.tradeTimeEnd = ''
        this.tradeTime = []
        this.showExportDialog = false
      }).catch(e => {
        this.exportLoading = false
      })
    },
    // 获取选择的筛选时间
    getSearchDate () {
      this.searchForm.enterTimeStart = this.inputTime[0]
      this.searchForm.enterTimeEnd = this.inputTime[1]
      this.searchForm.updateTimeStart = this.updateTime[0]
      this.searchForm.updateTimeEnd = this.updateTime[1]
      this.searchForm.bindCardTimeStart = this.bindTime[0]
      this.searchForm.bindCardTimeEnd = this.bindTime[1]
    },
    // 获取上传的图片
    uploadSuccess (data) {
      if (data.path) {
        this.merchant[data.valueName] = data.path
      } else {
        this.merchant[data.valueName] = ''
      }
    },
    // 下载身份证图片
    downloadIdCard (row) {
      const loading = this.$loading({
        text: '下载中'
      })
      this.$axios.post(this.$api.downloadIdCard, {
        id: row.id
      }, {
        responseType: 'blob'
      }).then(res => {
        loading.close()
        if ((res && res.respCode) || !res) {
          return
        }
        createDownLink(res, row.merchantCode + '_' + row.settleName + '.zip')
        this.$message({
          type: 'success',
          message: '下载成功！'
        })
      })
    },
    /**
     * @description 点击导出已绑卡商户【交易明细】按钮
     */
    toExportBankSummery () {
      this.exportTitle = '导出交易汇总（银行）'
      this.exportType = 'summeryBank'
      this.tradeTime = []
      this.tradeTimeStart = ''
      this.tradeTimeEnd = ''
      this.showExportDialog = true
    },
    getListText (status, list) {
      const result = list.filter(item => {
        return item.value === status
      })
      if (result.length === 0) {
        return '未知'
      } else {
        return result[0].text
      }
    },
    deleteActivity (row) {
      this.$confirm('是否确认删除该商户', '温馨提示').then(() => {
        const params = {
          activityId: this.info.activityId,
          bindCardStatus: row.status,
          merchantId: row.merchantCode,
          id: row.id
        }
        let key = ''
        if (this.info.type === 10) {
          key = 'deleteMerchant'
        } else {
          key = 'deleteRealTimeMerchant'
        }
        this.$axios.post(this.$api[key], params).then(response => {
          if (response.respCode === '0') {
            this.$message({
              message: '删除成功',
              type: 'success',
              showClose: true
            })
            this.getMerchantList()
          }
        })
      })
    },
    getExportHead () {
      this.$axios.get(this.$api.getExportHead).then(res => {
        if (res.respCode === '0') {
          this.quotaHeader = res.data
        }
      })
    },
    exportMerchantInfo () {
      this.getSearchDate()
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId,
        status: this.searchForm.status.join(','),
        selectedFields: this.quotaHeader.filter(item => item.isSelected).map(item => item.fieldName)
      })
      this.$axios.post(this.$api.exportInfo, params).then(res => {
        if (res.respCode === '0') {
          this.showExportDialog = false
          downJumpConfirm.call(this)
        }
      })
    },
    getBankByMerchantId () {
      this.$axios.post(this.$api.queryBankByMerchantId, {
        activityId: this.info.activityId
      }).then(res => {
        if (res.respCode === '0') {
          this.bankList = res.data
        }
      })
    },
    // getBankByAddress () {
    //   this.$axios.post(this.$api.queryBankList, {
    //     activityId: this.info.activityId,
    //     address: this.merchant.address
    //   }).then(res => {
    //     if (res.respCode === '0') {
    //       this.bankList = res.data.data
    //     }
    //   })
    // },
    // queryAutoBank () {
    //   if (!this.merchant.address.provinceNo || !this.merchant.address.cityNo) {
    //     this.$message({
    //       message: '请先选择地址后进行系统自动匹配',
    //       type: 'warning',
    //       showClose: true
    //     })
    //     return
    //   }
    //   this.queryLoading = true
    //   this.$axios.post(this.$api.queryAutoBank, {
    //     activityId: this.info.activityId,
    //     address: this.merchant.address
    //   }).then(res => {
    //     this.queryLoading = false
    //     if (res.respCode === '0') {
    //       if (res.data.data.length) {
    //         this.bankList = res.data.data
    //         this.$refs.cardBankNewId.$el.click()
    //       } else {
    //         this.$message({
    //           message: '当前智能匹配无数据，请从默认选项中选择',
    //           type: 'warning',
    //           showClose: true
    //         })
    //       }
    //     }
    //   })
    // },
    handleAssignmentBankChange (value) { // 开卡指派弹框银行网点下拉选项改变
      this.$set(this.assignmentForm, 'managerId', '')
      if (!value) {
        this.assignmentManagerList = []
        this.assignmentForm.cardBankNewId = ''
        return
      }
      this.$axios.post(this.$api.queryManager, {
        newCode: value
      }).then(res => {
        if (res.respCode === '0') {
          this.assignmentManagerList = res.data
        }
      })
    },
    handleBindFormaBankChange (value) { // 添加已绑卡商户弹框 银行网点change
      this.$set(this.boundForm, 'managerId', '')
      if (!value) {
        this.managerList = []
        return
      }
      this.$axios.post(this.$api.queryManager, {
        newCode: value
      }).then(res => {
        if (res.respCode === '0') {
          this.managerList = res.data
        }
      })
    },
    handleBankChange (value, useDefault = true) {
      if (!value) {
        this.managerList = []
        this.merchant.managerId = ''
        this.actualManagerList = []
        this.merchant.actualManagerId = ''
        return
      }
      this.$axios.post(this.$api.queryManager, {
        newCode: value
      }).then(res => {
        if (res.respCode === '0') {
          this.managerList = res.data
          this.actualManagerList = res.data
          if (useDefault) {
            this.merchant.managerId = ''
            this.merchant.actualManagerId = ''
            const result = this.managerList.filter(item => parseInt(item.status) === 1)
            if (result.length > 0) {
              this.merchant.managerId = result[0].managerId
              this.merchant.actualManagerId = result[0].managerId
            }
          }
        }
      })
    },
    hasData (obj) {
      let hasResult = true
      let total = 0
      // for (const key in obj) {
      //   total += 1
      //   if (obj[key] === undefined || obj[key] === '') {
      //     hasResult = false
      //   }
      // }
      // 解决sonar问题：for in循环会遍历原型链上的属性
      Object.keys(obj).forEach(key => {
        total += 1
        if (obj[key] === undefined || obj[key] === '') {
          hasResult = false
        }
      })
      return total && hasResult
    },
    jumpDownload () {
      this.showResultDialog = false
      this.$store.dispatch('delVisitedViews', {
        path: '/fileManage/downloadCenter'
      }).then(() => {
        this.$router.push('/fileManage/downloadCenter')
      })
    },
    importSubmit (result) {
      if (result) {
        this.getMerchantList()
      }
    },
    /**
           * @description 上传文件
           */
    getMultiFiles () {
      this.$refs.file.click()
    },
    /**
             * @description 删除已上传文件
             */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    /**
             * @description 选择文件
             */
    getFile (event) {
      const name = event.target.files[0].name.split('.')
      if (!['xls', 'xlsx'].includes(name[name.length - 1])) {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 1) {
        this.$message({
          message: '文件大小不得大于1M，请重新上传！',
          type: 'warning'
        })
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    clearMerchant () {
      this.merchantFlag = 'single'
      this.bindFlag = 'single'
      // this.multiFile = null
      this.multiFileName = ''
      this.openCardDemandList = []
    },
    resetBatchAssign () {
      this.multiFile = ''
      this.multiFileName = ''
    },
    batchAssign () {
      if (this.multiFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      // this.batchAddLoading = true
      const data = new FormData()
      data.append('activityId', this.info.activityId)
      data.append('multipartFile', this.multiFile)
      this.$axios.post(this.$api.batchOpenCard, data).then(res => {
        if (res.respCode === '0') {
          if (res.data && res.data.failMerchants && res.data.failMerchants.length > 0) {
            this.failMerchants = res.data.failMerchants.join(', ')
            this.successNum = res.data.successCount
            this.failNum = res.data.failCount
            this.failList = res.data.failMerchants
            this.showBatchAssignDialog = false
            this.showAssignResultDialog = true
            this.searchForm.pageNo = 1
            this.getMerchantList()
          } else {
            this.$message({
              type: 'success',
              message: res.respMsg + '，成功新增' + res.data.successCount + '条',
              showClose: true
            })
            this.searchForm.pageNo = 1
            this.getMerchantList()
            this.showBatchAssignDialog = false
          }
        }
      })
    },
    handleOpenAssignTabClick (tab) {
      if (tab.name === 'viewOpenAssignRecords') {
        this.getOpenCardAssign()
      }
    },
    checkOpenCardAssign (row) {
      this.clickedId = row.id
      this.openAssignFlag = 'updateOpenAssign'
      this.bindAssignId = row.merchantCode
      this.handleAssignmentBankChange(row.bankCode)
      this.assignmentForm.managerId = row.managerId
      this.assignmentForm.cardBankNewId = row.bankCode
      this.showOpenCardDialog = true
      this.assignPagination.pageNo = 1
    },
    openCardAssignConfirm () {
      if (this.openAssignFlag === 'updateOpenAssign') {
        this.updateOpenCard()
      } else {
        this.showOpenCardDialog = false
      }
    },
    getOpenCardAssign () {
      this.openCardLoading = true
      this.$axios.post(this.$api.queryOpenHistory, Object.assign({}, this.assignPagination, {
        merchantId: this.bindAssignId,
        activityId: this.info.activityId
      })).then(res => {
        this.openCardLoading = false
        if (res.respCode === '0') {
          this.openCardList = res.data.list
          this.assignPagination.total = res.data.count
        }
      })
    },
    toExportWithoutAppointment () { // 导出未预约商户
      this.exportType = 'withoutAppointment'
      this.exportTitle = '导出未预约商户'
      this.showExportDialog = true
    },
    updateOpenCard () { // 变更开卡指派
      const params = {
        ...this.assignmentForm,
        id: this.clickedId
      }
      this.$axios.post(this.$api.updateOpenCardAssign, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '开卡指派成功'
          })
          this.showOpenCardDialog = false
          this.getMerchantList() // 刷新列表
        }
      })
    },
    checkOpenCard (row) {
      this.openCardTab = 'updateOpenState'
      this.clickedId = row.id
      this.bindMerchantId = row.merchantCode
      this.showBindRecordDialog = true
      this.openCardUpdateForm.status = row.status
      this.clickedJoinState = row.joinState
      this.clickedOpenCardStatus = row.status
      this.bindPagination.pageNo = 1
    },
    getBindRecordList () {
      this.bindRecordLoading = true
      this.$axios.post(this.$api.queryOpenCardStatusRecord, Object.assign({}, this.bindPagination, {
        activityId: this.info.activityId,
        merchantId: this.bindMerchantId
      })).then(res => {
        this.bindRecordLoading = false
        // console.log(res)
        if (res.respCode === '0') {
          this.bindRecordList = res.data.list
          this.bindPagination.total = res.data.count
        }
      })
    },
    handleOpenCardTabClick (tab) {
      if (tab.name === 'viewUpdateRecords') {
        this.getBindRecordList()
      }
    },
    openCardDialogConfirm () { // 开卡状态弹框确认按钮点击
      if (this.openCardTab === 'viewUpdateRecords') {
        this.showBindRecordDialog = false
      } else {
        if (this.clickedJoinState !== 0) {
          this.showBindRecordDialog = false
          return
        }
        this.updateOpenCardStatus()
      }
    },
    updateOpenCardStatus () {
      const params = {
        ...this.openCardUpdateForm,
        id: this.clickedId
      }
      this.$axios.post(this.$api.updateOpenCardStatus, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.showBindRecordDialog = false
          this.getMerchantList() // 刷新列表
        }
      })
    }
  },
  watch: {
    // 'merchant.address': {
    //   handler (val, oldVal) {
    //     console.log(val)
    //     if (val && val.provinceNo && val.cityNo) {
    //       this.getBankByAddress()
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    isBank () {
      return this.$store.state.userInfo.userType === 4
    }
  }
}
</script>

<style lang="less" scoped>
.table{
  margin-top: 20px;
}
.merchantForm{
  .radioDiv{
    padding-top: 10px;
    padding-bottom: 20px;
  }
  .merchantIdInput{
    width: 300px;
    margin-right:20px
  }
}
.activityName{
  font-size: 18px;
  margin-bottom: 15px;
}
.activityId{
  font-size: 15px;
  color: #999;
  margin-bottom: 20px;
}
.timeTitle{
  font-size: 18px;
}
.info {
  color: #F6A23D;
}
.inlineSelect {
  margin-top: 25px;
  margin-bottom: 20px;
}
.inlineSelect .label {
  margin-right: 15px;
}
.add-info {
  font-size: 12px;
  margin-bottom: 12px;
}
.addResult {
  /deep/ .default {
    width: 600px !important;
  }
}
.item {
  .row {
    display: flex;
    flex-wrap: wrap;
    .btn {
      cursor: pointer;
      margin-right: 20px;
      margin-bottom: 20px;
      border-radius: 2px;
      border: 1px solid #DFDFDF;
      width: 130px;
      line-height: 16px;
      text-align: center;
      height: 32px;
      color: #666666;
      position: relative;
      &.active {
        border: 1px solid #1677ff;
        color: #1677ff;
        .mark {
          border-bottom-color: #1677ff;
          border-right-color: #1677ff;
        }
      }
      .mark {
        width: 0;
        height: 0;
        border: 12px solid #DFDFDF;
        border-top-color: transparent;
        border-left-color: transparent;
        position: absolute;
        right: 0;
        bottom: 0;
        i {
          position: absolute;
          font-size: 8px;
          color: #fff;
        }
      }
    }
  }
}
.divider {
  margin-top: 24px;
  height: 1px;
  background: #ccc;
  transform: scaleY(0.5)
}
.add-info {
  font-size: 12px;
}
.addResult {
  /deep/ .default {
    width: 600px !important;
  }
}
.batchImport {
  float: right
}
.hasSelect{
  font-size: 15px;
  margin-top: 20px;
}
.hasSelect span{
  // float: left;
  margin-bottom: 20px;
  line-height: 30px;
  display: inline-block;
  max-width: 430px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hasSelect .removeIcon{
  color:#F56C6C;
  line-height: 30px;
  cursor: pointer;
  margin-left: 10px;
}
.tips{
  margin: 0;
  margin-bottom: 20px;
  font-size: 14px;
  color: #acacac;
  line-height: 20px;
}
.check {
  margin-left:5px
}
.import-tip {
  color: #A3A3A4;
  font-size: 12px;
  margin-bottom: 20px;
}

.import {
  /deep/ .el-button {
    width: 100px;
    height: 30px;
    text-align: center;
    padding: 0;
    margin: 0 12px 12px 0;
  }
  margin-right: 12px;
  margin-bottom: 8px;
}
.add-info {
  font-size: 12px;
  padding-bottom: 8px;
}
</style>
<style lang="less" scoped>
.merchantForm{
  .el-input{
    width: 300px;
  }
  .addressSelect{
    .el-input{
      width: 100%;
    }
  }
  .el-textarea__inner{
    width: 546px;
  }
  .marginLeft{
    margin-left: 40px;
  }
  .displayBlock{
    display: block;
    margin-top: 10px;
  }
}
.title {
  margin-bottom: 24px;
  margin-right: 28px;
}
.check-merchant-view{
  .tips{
    margin-bottom: 10px;
    color: red;
  }
}
.DialogText {
  color: #A3A3A4
}
.hasSelect span{
  float: left;
  margin-bottom: 20px;
  line-height: 30px;
  display: inline-block;
  max-width: 430px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hasSelect .removeIcon{
  color:#F56C6C;
  line-height: 30px;
  cursor: pointer;
  margin-left: 10px;
}
.title-bold{
  font-size:18px;
  color:#333;
  font-weight:bold;
  margin-bottom:20px
}
</style>
